import { render, staticRenderFns } from "./MessageContent.vue?vue&type=template&id=8384fd46&scoped=true&"
import script from "./MessageContent.vue?vue&type=script&lang=js&"
export * from "./MessageContent.vue?vue&type=script&lang=js&"
import style0 from "./MessageContent.vue?vue&type=style&index=0&id=8384fd46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8384fd46",
  null
  
)

export default component.exports